import {
  Swiper, Keyboard, Navigation, FreeMode,
} from 'swiper';

const swiperContainerClass = '.floorplans__swiper';

function initSlider(container) {
  // eslint-disable-next-line no-new
  new Swiper(container, {
    slidesPerView: 'auto',
    spaceBetween: 24,
    modules: [Keyboard, Navigation, FreeMode],
    keyboard: {
      enabled: true,
    },
    freeMode: true,
    grabCursor: true,
    breakpoints: {
      992: {
        spaceBetween: 72,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      disabledClass: 'c-arrow--disabled',
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/floorplans', ($block) => {
      initSlider($block.find(swiperContainerClass)[0]);
    });
  } else {
    initSlider(swiperContainerClass);
  }
});
